// @ts-check
import React from 'react';
import styles from './ChooseSettingNotice.module.scss';

const ChooseSettingNotice = () => (
  <div className={styles.notice}>Choose one of the settings on the left.</div>
);

export default ChooseSettingNotice;
